
<div class="vincent_about2">
    <div class="row">
        <div class="col col-12 vincent_content">
            <div class="row vincent_reservation" style="flex-direction: row-reverse;">
                <div class="col col-12 vincent_reservation_block ">
                    <div class="relative-bottom">
                        <h1>أرشادات</h1>                        
                        <div class="row">
                            <div class="col-4">
                                <h2 class="procces">3</h2>
                                <p class="procces-dis">
                                    بالضغط علي تم التحضير في عرض الطلبات و عرض المعلومات الأضافية,يتم حذف البيانات من القاعدة,حتي يتم السماح للمستخدم بحجز طلبات أخري,بعد التأكيد سيتم أتاحة زر تم التحضير لحذف الطلب,يمكن أيضا حذف المستخدم تماما
                                </p>
                            </div>
                            <div class="col-4">
                                <h2 class="procces">2</h2>
                                <p class="procces-dis">
                                    المرحلة الثانية هي عرض المعلومات الأضافية التي تحتوي علي طريقة الدفع, الرسالة الأختيارية, وحالة الطلب, بعد مراجعة و عرض البيانات يرجي الضغط علي تأكيد
                                </p>
                            </div>
                            <div class="col-4">
                                <h2 class="procces">1</h2>
                                <p class="procces-dis">
                                    سيتم عرض بيانات الطلب في هيئة منفصلة,الأولي منها هي الطلبات, سيظهر لك كلمة"عرض الطلبات" تأكد من الضغط عليها ليتم عرضهم,بعد الأنتهاء من كل طلب يرجي التأكد من الضغط علي "تم التحضير" بجانب كل طلب
                                </p>
                            </div>
                        </div>
                        <div class="vincent_form_block">
                            <a class="vincent_button" (click)="enterOrders()"> الدخول</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
